import axios from 'axios';
import apiConfig from '../api.config';

export default function updateOwnerRequest({ chainName, userId, name, phone, hotelId }) {
  const {
    host,
    URIs: { owner },
  } = apiConfig;

  const uri = `${host}${owner}/${userId}`;

  return axios
    .put(uri, JSON.stringify({ chainName, name, phone, hotelId }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
